import store from 'store'
import Langauge from "../i18n/Language";
const t = Langauge;

//pagespeed 检测
export const PAGESPEED_KEY = process.env.REACT_APP_PAGESPEED_KEY;

/**
 * 存储localStorage
 */
let setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    // window.localStorage.setItem(name, content);
    try {
        store.set(name, content);
    } catch (e) {
        console.info(e);
    }
}

/**
 * 获取localStorage
 */
let getStore = name => {
    if (!name) return;
    // return window.localStorage.getItem(name);
    try {
        return store.get(name);
    } catch (e) {
        console.info(e);
    }
}

/**
 * 删除localStorage
 */
let removeStore = name => {
    if (!name) return;
    // window.localStorage.removeItem(name);
    try {
        store.remove(name);
    } catch (e) {
        console.info(e);
    }
}

// 路由跳转
let routeJump = (_this, to, state = undefined, query = undefined) => {
    let curUrl = window.location.pathname;
    if (to === curUrl) {
        return false
    } else {
        let params = {
            pathname: to,
        }
        if (state !== undefined) {
            params['state'] = state
        }
        if (query !== undefined) {
            params['query'] = query
        }
        _this.props.history.push(params)
    }
}

// 复制文本
let CopyText = async (text = '') => {
    // // 动态创建 textarea 标签
    // const textarea = document.createElement('textarea');
    // // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
    // textarea.readOnly = 'readonly';
    // textarea.style.position = 'absolute';
    // textarea.style.left = '-9999px';
    // // 将要 copy 的值赋给 textarea 标签的 value 属性
    // textarea.value = text;
    // // 将 textarea 插入到 body 中
    // document.body.appendChild(textarea);
    // // 选中值并复制
    // textarea.select();
    // const result = document.execCommand('Copy');
    // if (textarea) {
    //     document.body.removeChild(textarea);
    // }
    // return result;
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (e) {
            console.warn('Clipboard API Error:', e);
        }
    }

    // Fallback：兼容旧浏览器（非安全上下文、非 https）
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.readOnly = true;
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    const success = document.execCommand('copy');
    document.body.removeChild(textarea);
    return success;
}

// 首节流
let throttleStart = (func, delay) => {
    let lastCallTime = 0;
    return function () {
        const now = new Date().getTime();
        if (now - lastCallTime >= delay) {
            func.apply(this, arguments);
            lastCallTime = now;
        }
    };
}

// 尾节流
let throttleEnd = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        if (!timer) {
            timer = setTimeout(() => {
                fn.apply(context, args);
                timer = null;
            }, delay);
        }
    }
}

// 防抖
const debounceDIY = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
};
// 重设监听方法
const setupResizeObserver = () => {
    const _ResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
        constructor(callback) {
            callback = debounceDIY(callback, 16);
            super(callback);
        }
    };
};

// 时间格式化
const timeFormat = (timestamp, split = '-', showHMS = true) => {
    // 创建一个 Date 对象
    let date = new Date(timestamp * 1000); // 时间戳是以秒为单位的，所以乘以1000转换为毫秒
    // 提取年、月、日
    let year = date.getFullYear();
    let month = date.getMonth() + 1; // 注意月份从0开始，需要加1
    let day = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    // 格式化为指定格式
    let formattedDate = year + split + (month < 10 ? '0' : '') + month + split + (day < 10 ? '0' : '') + day;
    let formattedTime = (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
    return showHMS ? formattedDate + ' ' + formattedTime : formattedDate;
}

// 美式时间格式化
const formatUSATime = (timestamp) => {
    // 创建一个新的 Date 对象，传入时间戳（秒为单位）
    let date = new Date(timestamp * 1000);
    // 定义月份名称
    let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // 提取年、月、日、小时、分钟、上午/下午
    let year = date.getFullYear();
    let month = monthNames[date.getMonth()];
    let day = date.getDate();
    // 组合成指定格式的字符串
    let formattedDate = t(month) + ' ' + (day < 10 ? '0' + day : day) + ', ' + year;
    return formattedDate;
}

// 匹配 [[{"value":"xxx"}]] - 兼容 Tagify
const normalizeMixValue = (value, allowList) => {
    return value.replace(
        /\[\[\s*\{\s*"value"\s*:\s*"([^"]+)"\s*\}\s*\]\]/g,
        (_, tagValue) => {
            // 去掉 {{ }}
            const cleanValue = tagValue.replace(/^\{\{|\}\}$/g, '');
            // ✅ 合法 tag
            if (allowList.includes(cleanValue)) {
                return `[[{"value":"${tagValue}"}]]`;
            }
            // ❌ 非法 tag → 还原为普通文本
            return cleanValue;
        }
    );
};

// 下载图片
const downloadImage = async (href, filename = '') => {
    try {
        const response = await fetch(href, {
            mode: "cors", // 跨域资源必须启用 CORS
        });
        if(response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename; // 自定义文件名
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }
    return true;
}

/**
 * HTML 属性上下文转义
 * 用途：用户输入最终会被注入到 <meta content="...">、<img alt="..."> 等
 *      HTML 属性里，只转会破坏属性/标签结构的字符，不限制用户输入内容。
 * 幂等：已转义的实体不会被二次转义，可在 onChange / onBlur / 保存等多处安全调用。
 * 注意：这是「HTML 属性」上下文的转义，不适用于 JSON-LD、llms.txt、
 *      纯文本等其它输出上下文（它们需要各自的转义规则）。
 */
const escapeHtmlAttr = (val) => {
    if (typeof val !== 'string') return val;
    return val
        // & 仅在不属于已有实体时才转，避免二次转义（&amp; 不会再变成 &amp;amp;）
        .replace(/&(?!(?:amp|lt|gt|quot|#39|#96);)/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/`/g, '&#96;');
}

/**
 * 安全打开外部链接
 * 用途：接口/广告返回的 url 直接 window.open 存在两类风险：
 *      ① javascript:/data: 等伪协议 → XSS；② 反向 tabnabbing（新标签页可访问 window.opener）。
 * 本方法只放行 http/https，并默认加 noopener,noreferrer。
 * 注意：加了 noopener 后 window.open 返回 null，需要引用返回窗口做后续通信的场景
 *      （如 OAuth 弹窗 postMessage）请勿使用本方法。
 */
const safeOpen = (url, target = '_blank', features) => {
    if (typeof url !== 'string' || !url) return null;
    let parsed;
    try {
        parsed = new URL(url, window.location.origin);
    } catch (e) {
        return null;
    }
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    // 未指定窗口特性（普通新标签页）时补 noopener,noreferrer 防反向 tabnabbing；
    // 指定了 features（弹窗，通常需要引用返回的 window 做后续通信）则原样传递，保留 opener 与返回引用。
    const feat = features == null ? 'noopener,noreferrer' : features;
    return window.open(parsed.href, target, feat);
}

let utilsFunc = {
    setStore,
    getStore,
    removeStore,
    // routeListen,
    routeJump,
    CopyText,
    throttleStart,
    throttleEnd,
    debounceDIY,
    setupResizeObserver,
    timeFormat,
    formatUSATime,
    normalizeMixValue,
    downloadImage,
    escapeHtmlAttr,
    safeOpen,
};

export { escapeHtmlAttr };

export default utilsFunc;